import React, { useState, useEffect } from "react";
//component
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import { categoriesCollection } from "../../../components/firebase/DataProvider";
import { useDocumentDataOnce } from "react-firebase-hooks/firestore";
//slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
//material comoponent
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";
import Button from "@material-ui/core/Button";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ScrollContainer from "react-indiana-drag-scroll";

//style
import useStyles from "./style/kategoriPopulerStyle";
import { useHistory } from "react-router-dom";
import { useMediaQuery, useTheme } from "@material-ui/core";

function Item({ id, key, load }) {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const miniScreen = useMediaQuery(theme.breakpoints.down("600"));
  const [data] = useDocumentDataOnce(categoriesCollection.doc(id), {
    idField: "id",
  });

  // seceleton
  const [sece, setSece] = useState();
  setTimeout(() => {
    setSece(data);
  }, 1000);

  return (
    <div
      className={classes.wrapper}
      onClick={() =>
        history.push(`/kategori/kategori3/${data.nama}/${data.id}`, {
          data: data,
        })
      }
      key={key}
    >
      {load || !sece ? (
        <div>
          <Skeleton
            variant="rect"
            style={{
              width: miniScreen ? 80 : 80,
              height: miniScreen ? 80 : 80,
            }}
          />
          <Skeleton
            variant="text"
            style={{
              width: miniScreen ? 80 : 80,
            }}
          />
        </div>
      ) : (
        <Card className={classes.card}>
          <CardActionArea>
            <div className={classes.wrapImg}>
              <img
                src={data?.icon}
                className={classes.medium}
                alt={data?.nama ?? "N/A"}
              />
            </div>
          </CardActionArea>
          <div className={classes.content}>
            <Typography className={classes.title} component="p">
              {data?.nama ?? "N/A"}
            </Typography>
          </div>
        </Card>
      )}
    </div>
  );
}

function KategoriPopuler() {
  const classes = useStyles();
  const history = useHistory();

  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const miniScreen = useMediaQuery(theme.breakpoints.down("600"));
  useEffect(() => {
    async function getItems() {
      try {
        setIsLoading(true);
        const getPopular = firefunctions.httpsCallable("getPopular");

        const response = await getPopular({ find_by: "kategori3" });

        setItems(response.data.popular_items);
        setIsLoading(false);
      } catch (e) {
        console.log(e.message);
        setIsLoading(false);
      }
    }
    getItems();
  }, []);

  return (
    <Paper elevation={0} className={classes.container}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ marginTop: 5, marginBottom: 15, marginLeft: -10 }}>
          <Typography
            style={{
              fontSize: "13px",
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            Kategori Populer
          </Typography>
        </div>
        <div>
          <Button
            size="small"
            endIcon={<ArrowRightIcon />}
            onClick={() => history.push("/kategori")}
          >
            <Typography style={{ fontSize: "11px" }}>Lihat semua</Typography>
          </Button>
        </div>
      </div>
      <div className={classes.wrapKategori}>
        {isLoading ? (
          <>
            <div>
              <Skeleton
                variant="rect"
                style={{
                  width: "100%",
                  height: miniScreen ? 80 : 80,
                }}
              />
              <Skeleton
                variant="text"
                style={{
                  width: "100%",
                }}
              />
            </div>
          </>
        ) : (
          <ScrollContainer className={classes.wrapScroll}>
            {items.map((item, index) => {
              return (
                <Item id={item.kategori3_id} key={index} load={isLoading} />
              );
            })}
          </ScrollContainer>
        )}
      </div>
    </Paper>
  );
}

export default KategoriPopuler;
